// Tracks which Problem Hands the member has played, so the list can show a tick.
//
// Since 11 Sep 2026 the record of truth is the member's account: membersData
// completedPractice.problemHands, the same array-per-category the trainers use
// (saved through savePracticeCompletion in usersActions). Paul: "move problem
// hands ticks into the account" - so a member sees the same ticks on every device.
//
// localStorage is kept as a per-device fallback: guests (who cannot play anyway)
// and the moment before the account has loaded. Ticks that only exist locally are
// pushed into the account the first time the signed-in member opens the list.
const KEY = "bridgechamps_ph_played";
export const PH_CATEGORY = "problemHands";

export function getPlayedMap() {
  try {
    if (typeof localStorage === "undefined") return {};
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
}

export function markPlayed(id) {
  try {
    if (typeof localStorage === "undefined" || !id) return;
    const map = getPlayedMap();
    if (map[id]) return;
    map[id] = true;
    localStorage.setItem(KEY, JSON.stringify(map));
  } catch (e) {
    // ignore
  }
}

/** { [id]: true } from the account list plus the local map. */
export function mergePlayed(accountList, localMap) {
  const out = {};
  (Array.isArray(accountList) ? accountList : []).forEach((id) => { out[id] = true; });
  Object.keys(localMap || {}).forEach((id) => { if (localMap[id]) out[id] = true; });
  return out;
}

/** Ids ticked on this device that the account does not have yet. */
export function localOnly(accountList, localMap) {
  const have = new Set(Array.isArray(accountList) ? accountList : []);
  return Object.keys(localMap || {}).filter((id) => localMap[id] && !have.has(id));
}
